import { render, staticRenderFns } from "./applygj.vue?vue&type=template&id=4e49487e&scoped=true&"
import script from "./applygj.vue?vue&type=script&lang=js&"
export * from "./applygj.vue?vue&type=script&lang=js&"
import style0 from "./applygj.vue?vue&type=style&index=0&id=4e49487e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e49487e",
  null
  
)

export default component.exports